(function () {
  'use strict';

  var SECTION_SELECTOR = '[data-section-id].pdp-formula-cards';
  var SWIPER_SELECTOR = '.pdp-formula-cards__swiper';
  var PAGINATION_SELECTOR = '.pdp-formula-cards__pagination';
  var MOBILE_MAX = 991;

  function initSwiper(section) {
    var swiperEl = section.querySelector(SWIPER_SELECTOR);
    if (!swiperEl) return;
    if (typeof window.Swiper === 'undefined') {
      requestAnimationFrame(function () { initSwiper(section); });
      return;
    }

    var slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
    if (slideCount === 0) return;

    var featuredIndex = parseInt(section.getAttribute('data-featured-index'), 10);
    if (isNaN(featuredIndex) || featuredIndex < 0) featuredIndex = 1;
    if (featuredIndex >= slideCount) featuredIndex = slideCount - 1;

    section._formulaCardsSwiper = new window.Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      centeredSlides: true,
      initialSlide: featuredIndex,
      grabCursor: true,
      slideToClickedSlide: true,
      pagination: {
        el: section.querySelector(PAGINATION_SELECTOR),
        clickable: true,
      },
    });
  }

  function destroySwiper(section) {
    if (section._formulaCardsSwiper) {
      section._formulaCardsSwiper.destroy(true, true);
      section._formulaCardsSwiper = null;
    }
  }

  function initSection(section) {
    if (!section.querySelector(SWIPER_SELECTOR)) return;
    if (window.matchMedia('(max-width: ' + MOBILE_MAX + 'px)').matches) {
      destroySwiper(section);
      initSwiper(section);
    }
  }

  function init() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(function (section) {
      initSection(section);
    });
  }

  function onSectionLoad(e) {
    var target = e.target;
    var section = target.querySelector ? target.querySelector(SECTION_SELECTOR) : target.closest(SECTION_SELECTOR);
    if (section) initSection(section);
  }

  function onSectionUnload(e) {
    var target = e.target;
    var section = target.querySelector ? target.querySelector(SECTION_SELECTOR) : target.closest(SECTION_SELECTOR);
    if (section) destroySwiper(section);
  }

  function syncSectionToViewport(section) {
    var isMobile = window.matchMedia('(max-width: ' + MOBILE_MAX + 'px)').matches;
    var swiper = section._formulaCardsSwiper;
    if (isMobile) {
      if (swiper) {
        swiper.update();
      } else if (section.querySelector(SWIPER_SELECTOR)) {
        initSwiper(section);
      }
    } else if (swiper) {
      destroySwiper(section);
    }
  }

  var media = window.matchMedia('(max-width: ' + MOBILE_MAX + 'px)');
  if (media.addEventListener) {
    media.addEventListener('change', function (e) {
      document.querySelectorAll(SECTION_SELECTOR).forEach(function (section) {
        if (e.matches) {
          initSection(section);
        } else {
          destroySwiper(section);
        }
      });
    });
  }

  var resizeTimeout;
  function onResize() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function () {
      document.querySelectorAll(SECTION_SELECTOR).forEach(function (section) {
        syncSectionToViewport(section);
      });
    }, 100);
  }
  window.addEventListener('resize', onResize);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', onSectionLoad);
  document.addEventListener('shopify:section:unload', onSectionUnload);
})();
